// On-brand generic placeholder images per service category.
// Used as the fallback when a service/provider has no uploaded image.
const IMAGES = {
  "wellness": "/categories/wellness.jpg",
  "fitness": "/categories/fitness.jpg",
  "beauty": "/categories/beauty.jpg",
  "education": "/categories/education.jpg",
  "home services": "/categories/home-services.jpg",
  "home": "/categories/home-services.jpg",
  "automotive": "/categories/automotive.jpg",
  "general": "/categories/general.jpg",
};

export const CATEGORY_FALLBACK = "/categories/general.jpg";

export function hasCategoryImage(category) {
  if (!category) return false;
  return Object.prototype.hasOwnProperty.call(IMAGES, category.trim().toLowerCase());
}

export function categoryImage(category) {
  if (!category) return CATEGORY_FALLBACK;
  return IMAGES[category.trim().toLowerCase()] || CATEGORY_FALLBACK;
}
